(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flipped-header"]) return;
  try {
    
const fsToggle=document.querySelector('.fs-menu-toggle');
const fsPanel=document.querySelector('.fs-side-menu');
const fsBackdrop=document.querySelector('.fs-menu-backdrop');
const fsClose=document.querySelector('.fs-menu-close');
if(fsToggle&&fsPanel&&fsBackdrop&&fsClose){
let previousFocus=null;
function openMenu(){previousFocus=document.activeElement;fsPanel.hidden=false;fsBackdrop.hidden=false;fsToggle.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';fsClose.focus();}
function closeMenu(){fsPanel.hidden=true;fsBackdrop.hidden=true;fsToggle.setAttribute('aria-expanded','false');document.body.style.overflow='';if(previousFocus&&previousFocus.focus)previousFocus.focus();}
fsToggle.addEventListener('click',()=>fsPanel.hidden?openMenu():closeMenu);
fsClose.addEventListener('click',closeMenu);
fsBackdrop.addEventListener('click',closeMenu);
fsPanel.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
document.addEventListener('keydown',e=>{if(fsPanel.hidden)return;if(e.key==='Escape'){e.preventDefault();closeMenu();return;}if(e.key==='Tab'){const items=Array.from(fsPanel.querySelectorAll('a[href],button:not([disabled])'));const first=items[0],last=items[items.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
}
import('@theme/events').then(({CartAddEvent,ThemeEvents})=>{document.addEventListener(ThemeEvents.cartUpdate,event=>{const cartLink=document.querySelector('.fs-cart');if(!cartLink||event.detail?.data?.didError)return;const count=event.detail?.resource?.item_count;if(typeof count==='number'){const span=cartLink.querySelector('span');if(span)span.textContent='('+count+')';}if(event instanceof CartAddEvent)window.location.assign(cartLink.href);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
